var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s69olg4xwa",
    d: "M3.125 13.542h2.083v-2.084H3.125v2.084zm0 4.166h2.083v-2.083H3.125v2.083zm0-8.333h2.083V7.292H3.125v2.083zm4.167 4.167h14.583v-2.084H7.292v2.084zm0 4.166h14.583v-2.083H7.292v2.083zm0-10.416v2.083h14.583V7.292H7.292z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -25) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rxae5a6gyb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s69olg4xwa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#rxae5a6gyb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcList);
export default __webpack_public_path__ + "static/media/ic-list.204875e384267224496be5daf502425a.svg";
export { ForwardRef as ReactComponent };